import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export default function Footer() {
  const { t } = useTranslation()

  return (
    <footer className="bg-cardBg border-t-2 border-slate-200 dark:border-slate-800 py-12 px-4 text-center transition-colors">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-8 h-8 bg-brand rounded-full animate-pulse shadow-[0_0_10px_var(--shadow-color)]" />
          <span className="text-2xl font-black tracking-tighter uppercase italic">
            {t('footer.brand')}
          </span>
        </div>

        <div className="flex flex-wrap justify-center gap-8 mb-8 text-sm font-black uppercase tracking-widest text-slate-500 dark:text-slate-300">
          <Link
            to="/privacy"
            className="hover:text-neonBlue transition-colors decoration-2 hover:underline underline-offset-4"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            className="hover:text-neonPink transition-colors decoration-2 hover:underline underline-offset-4"
          >
            Terms
          </Link>
        </div>

        <p className="text-slate-500 dark:text-slate-400 font-bold text-xs">
          {t('footer.copyright')}
        </p>
      </div>
    </footer>
  )
}
